import { CirclePause } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Popover, PopoverTrigger } from 'components/popovers/popover';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';
import { usePausedConsultations } from 'hooks/usePausedConsultations';
import { PausedConsultationsPanel } from './PausedConsultationsPanel';
import { Badge, IndicatorButton, OverlayContent } from './PausedConsultationsIndicator.styles';

export const PausedConsultationsIndicator = () => {
  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();
  const { consultations } = usePausedConsultations();

  if (!consultations.length) return null;

  const label = t('home.pausedConsultations.heading', { count: consultations.length });

  return (
    <Popover
      onOpenChange={(open) => {
        if (open) {
          trackEvent(ANALYTICS_EVENTS.TITLEBAR_PAUSED_CONSULTATIONS_OPENED, {
            count: consultations.length,
          });
        }
      }}
    >
      <PopoverTrigger asChild>
        <IndicatorButton aria-label={label}>
          <CirclePause className="size-5" />
          <Badge aria-hidden="true">{consultations.length}</Badge>
        </IndicatorButton>
      </PopoverTrigger>
      <OverlayContent align="end" aria-label={label} data-ph-no-autocapture>
        <PausedConsultationsPanel label={label} consultations={consultations} />
      </OverlayContent>
    </Popover>
  );
};
